import * as yup from 'yup'

export const partialRmaSchema = yup.object().shape({
  refundType: yup.string().required('Refund Type is required'),
  products: yup
    .array()
    .of(
      yup.object().shape({
        productId: yup.string().required('Product Id is required'),
        barcode: yup.string().required('Barcode is required'),
        returnQty: yup
          .number()
          .typeError('Return quantity is required')
          .min(0, 'Quantity must be at least 0')
          .required('Return quantity is required')
          .test(
            'max-decimals',
            'Only up to 3 decimal places are allowed',
            (value) => {
              if (value === undefined) return true

              // Convert to string and check decimal part
              const str = value.toString()
              const decimal = str.split('.')[1]
              return !decimal || decimal.length <= 3
            },
          ),

        reason: yup
          .string()
          .optional()
          .test('reason-test', 'Return reason is required', function (value) {
            const {
              parent: { returnQty },
            } = this

            return !(returnQty > 0 && !value)
          }),
        condition: yup
          .string()
          .optional()
          .test('condition-test', 'Condition is required', function (value) {
            const {
              parent: { returnQty },
            } = this

            return !(returnQty > 0 && !value)
          }),
      }),
    )
    .required('Rma is required'),
})

export const fullRmaSchema = yup.object().shape({
  refundType: yup.string().required('Refund Type is required'),
  reason: yup.string().required('Reason is required'),
  condition: yup.string().required('Condition is required'),
})
